// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_3U-5S","logo":"index_logo_2SrCc","logoAnimate":"index_logoAnimate_3ia2L","mainLogo":"index_mainLogo_1tzAE","version":"index_version_3O7Mu"};